import { useState, useEffect } from "react";
import axios from "axios";

import GestaoEquipamento from './components/gestao-equipamentos/GestaoEquipamentos.js';
import GestaoTiposProblemas from './components/gestao-tipoproblemas/GestaoTiposProblemas.js';
import DashboardChamado from './components/dashboard-chamados/DashboardChamados.js';
import NovoChamado from './components/Novo-chamado.js';
import VerChamadoAberto from './components/dashboard-chamados/components/Ver-chamado-aberto.js';
import VerChamadoAtendimento from './components/dashboard-chamados/components/Ver-chamado-atendimento.js';
import EditarChamado from './components/dashboard-chamados/components/Editar-chamado.js';
import AtenderChamado from './components/dashboard-chamados/components/Atender-chamado.js';
import GestaoContrato from './components/gestao-contrato/GestaoContrato.js';
import FinalizarChamado from './components/dashboard-chamados/components/Finalizar-chamado.js';
import VerChamadoFinalizado from './components/dashboard-chamados/components/Ver-chamado-finalizado.js';
import VerChamadoCanelado from './components/dashboard-chamados/components/Ver-chamado-cancelado.js';
import Apontamentos from './components/dashboard-chamados/components/Apontamento.js';
import ListaApontamentosGeral from './components/dashboard-chamados/components/ListaApontamentoGeral.js';

import GlobalStyle from "../../styles/global-new.js";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { IoMdArrowRoundBack } from "react-icons/io";

import RedButton from "../ui/RedButton.js";

import logo1 from "../../styles/imagem/logo-1.png";
import logo2 from "../../styles/imagem/logo-2.png";
import logo3 from "../../styles/imagem/logo-3.png";
import logo4 from "../../styles/imagem/logo-4.png";
import logo5 from "../../styles/imagem/logo-5.png";


const Div = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;

`;



const Div2 = styled.div`
  width: auto;
  border-radius: 10px;
`;

const DivLayout = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
    gap: 10px;

`;

const Container = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  box-sizing: border-box;
  border-radius: 15px;
  border: 1px solid #eee;


`;

const Title = styled.nav`
  width: 90%;
  display: flex;
  justify-content: space-between; 
  align-items: center;
  height: 8.0rem;
  background: #fff;
  border-radius:  15px;
  border: 1px solid #eee;

`;
const TitleInt = styled.nav`
  width: 100%;
  display: flex;
  justify-content: space-between; 
  align-items: center;
  flex-direction: column;
  background: #fff;




`;

const Title2 = styled.h2`
  display: flex;
  justify-content: space-between; 
  align-items: center;
  width: 100%;
  color: #008000;
  font-size: 28px;

  @media (max-width: 768px) {
    font-size: 20px;
    width: 90%;
  }

`;

const DivTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center; 
  gap: 50px;
  padding-left: 10px;
  
`;






const Button = styled.button`
  background-color: #E5F7EE;
  color: #008000;
  font-size: 20px;
  font-weight: 600;
  padding: 8px 16px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #d3f0e2;
  }

  @media (max-width: 780px) {
    font-size: 14px;
    padding: 6px 12px;
  }
  
`;

const DivBotoes = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
`;



const ButtonContainer = styled.div`
  display: flex;
  justify-content: end; 
  margin: 5px;
`;


const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  
`;
const ModalContent = styled.div`
  background-color: #fafafa;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  max-height: 90vh; 
  overflow-y: auto; 
  border-radius: 10px;
  

`;
const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  gap: 10px;
  transition: transform .12s ease;
  &:hover { transform: scale(1.03); }
`;

export const ZoomWrapper = styled.div`
  transform-origin: top left;
  ${({ scale }) => `
    transform: scale(${scale});
    /* truque: compensa a largura para não cortar quando escala > 1 */
    width: ${(100 / scale).toFixed(4)}%;
  `}
`;

function Usuarios() {

  const urlFront = process.env.REACT_APP_FRONT_URL;
  const urlApi = process.env.REACT_APP_API_URL;

  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');




  //-----------------------------------------------------------------------------------------------------------//

  //Links
  const handleVoltarDash = () => {
    window.location.href = urlFront;
  };
  //-----------------------------------------------------------------------------------------------------------//

  //Verifica o token do usuário
  const [tToken, setToken] = useState("");
  const getToken = async () => {
    try {
      const res = await axios.get(`${urlApi}logon/token`, { headers: { Authorization: `Bearer ${token}` } });
      setToken(res.data);
    } catch (error) {
      if (error.response && (error.response.status === 400 || error.response.status === 403 || error.response.status === 401)) {
        window.location.href = `${urlFront}login`;
      } else {
        console.error("Erro ao obter token:", error);
      }
    }
  };

  useEffect(() => {

    getToken();

  }, [])




  //---------------------TIPO DE USUÀRIO-----------//

  const [tipoAcessoModulo8, setTipoAcessoModulo8] = useState(null);

  const fetchAcessos = async () => {
    try {
      const res = await axios.post(`${urlApi}portal/acessos-portal`,
        { id },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Busca o objeto do módulo 8
      const modulo8 = res.data.find(item => item.COD_MODULO === 8);


      if (modulo8) {
        setTipoAcessoModulo8(modulo8.TIPO_ACESSO);
      } else {
        setTipoAcessoModulo8(null); // ou algum valor padrão caso não encontre
      }

    } catch (error) {
      console.error('Erro ao buscar dados de acessos:', error);
    }
  };


  useEffect(() => {


    fetchAcessos();
  }, [token, id]);






  //---------------------IMAGEM DE CARREGANDO-----------//
  const [abaAtiva, setAbaAtiva] = useState("dashboard");
  const [loadingImage, setLoadingImage] = useState(null);

  const imagens = [logo1, logo2, logo3, logo4, logo5];

  const trocarAbaComImagem = (novaAba) => {
    const imagemAleatoria = imagens[Math.floor(Math.random() * imagens.length)];
    setLoadingImage(imagemAleatoria);

    setTimeout(() => {
      setLoadingImage(null);
      setAbaAtiva(novaAba);
    }, 1000);
  };

  useEffect(() => {
    trocarAbaComImagem("dashboard"); // define o nome da aba ativa
  }, []);





  //------------------------------------------TIPO/SUBTIPO MATERIAL-----------------------------------------------------------------//
  const [atualizaPagina, setAtualizaPagina] = useState(false);

  const [usuarioEquipamento, setUsuarioEquipamento] = useState([]);
  const [tipoChamado, setTipoChamado] = useState([]);
  const [subTipoChamado, setSubTipoChamado] = useState([]);
  const [itemSubTipoChamado, setItemSubTipoChamado] = useState([]);



  const getBase = async () => {
    try {

      const res0 = await axios.get(`${urlApi}central-ti/usuario-equipamento`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsuarioEquipamento(res0.data);

      const res1 = await axios.get(`${urlApi}central-ti/tipo-chamado`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTipoChamado(res1.data);

      const res2 = await axios.get(`${urlApi}central-ti/sub-tipo-chamado`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSubTipoChamado(res2.data);

      const res3 = await axios.get(`${urlApi}central-ti/item-sub-tipo-chamado`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setItemSubTipoChamado(res3.data);

      setAtualizaPagina(false);
    } catch (err) {
      console.log("Conexão falhou", err);
    }
  };


  useEffect(() => {
    getBase();
  }, [atualizaPagina]);


  //------------------------------------------DASHBOARDCHAMADOS-----------------------------------------------------------------//

  const [atualizaDasboard, setAtualizaDasboard] = useState(false);

  const [listaChamadoAberto, setListaChamadoAberto] = useState([]);
  const [listaChamadoAtendimento, setListaChamadoAtendimento] = useState([]);
  const [listaChamadoFinalizado, setListaChamadoFinalizado] = useState([]);
  const [listaChamadoCancelado, setListaChamadoCancelado] = useState([]);
  const [listaChamadoTotal, setListaChamadoTotal] = useState([]);
  const [quantidadeChamado, setQuantidadeChamado] = useState([]);



  const getDashboard = async () => {
    fetchAcessos();
    try {

      const res10 = await axios.get(`${urlApi}central-ti/lista-chamado-aberto`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (tipoAcessoModulo8 != null) {
        if (tipoAcessoModulo8 === 'S') {
          const filtrarChamados = res10.data.filter(a => a.COD_FUNCIONARIO_SOLICITANTE == id || a.COD_FUNCIONARIO == id);
          setListaChamadoAberto(filtrarChamados);
        } else {
          setListaChamadoAberto(res10.data);
        }
      }


      const res20 = await axios.get(`${urlApi}central-ti/lista-chamado-atendimento`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (tipoAcessoModulo8 != null) {
        if (tipoAcessoModulo8 === 'S') {
          const filtrarChamados = res20.data.filter(a => a.COD_FUNCIONARIO_SOLICITANTE == id || a.COD_FUNCIONARIO == id);
          setListaChamadoAtendimento(filtrarChamados);
        } else if (tipoAcessoModulo8 === 'A') {
          const filtrarChamados = res20.data.filter(a => a.COD_FUNCIONARIO_SOLICITANTE == id || a.COD_ADMIN_ATENDEU == id || a.COD_FUNCIONARIO == id);
          setListaChamadoAtendimento(filtrarChamados);
        } else {
          setListaChamadoAtendimento(res20.data);
        }
      }


      const res2 = await axios.get(`${urlApi}central-ti/quantidade-chamado`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setQuantidadeChamado(res2.data);
      setLastUpdated(new Date());
      setAtualizaDasboard(false);
    } catch (err) {
      console.log("Conexão falhou", err);
    }
  };



  useEffect(() => {
    if (tipoAcessoModulo8 !== null) {
      getDashboard();
    }
  }, [atualizaDasboard, tipoAcessoModulo8]);




  const [atualizaFinalizados, setAtualizaFinalizados] = useState(null);
  const getDashboardFinalizado = async () => {
    try {

      const res30 = await axios.get(`${urlApi}central-ti/lista-chamado-finalizado`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (tipoAcessoModulo8 === 'S') {
        const filtrarChamados = res30.data.filter(a => a.COD_FUNCIONARIO_SOLICITANTE == id || a.COD_FUNCIONARIO == id);
        setListaChamadoFinalizado(filtrarChamados);
      } else if (tipoAcessoModulo8 === 'A') {
        const filtrarChamados = res30.data.filter(
          a => a.COD_FUNCIONARIO_SOLICITANTE == id || a.COD_ADMIN_ATENDEU == id || a.COD_FUNCIONARIO == id
        );
        setListaChamadoFinalizado(filtrarChamados);
      } else {
        setListaChamadoFinalizado(res30.data);
      }

      const res40 = await axios.get(`${urlApi}central-ti/lista-chamado-cancelado`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (tipoAcessoModulo8 === 'S') {
        const filtrarChamados = res40.data.filter(a => a.COD_FUNCIONARIO_SOLICITANTE == id || a.COD_FUNCIONARIO == id);
        setListaChamadoCancelado(filtrarChamados);
      } else if (tipoAcessoModulo8 === 'A') {
        const filtrarChamados = res40.data.filter(
          a => a.COD_FUNCIONARIO_SOLICITANTE == id || a.COD_ADMIN_ATENDEU == id || a.COD_FUNCIONARIO == id
        );
        setListaChamadoCancelado(filtrarChamados);
      } else {
        setListaChamadoCancelado(res40.data);
      }

      const res50 = await axios.get(`${urlApi}central-ti/lista-chamado-total`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (tipoAcessoModulo8 === 'S') {
        const filtrarChamados = res50.data.filter(a => a.COD_FUNCIONARIO_SOLICITANTE == id || a.COD_FUNCIONARIO == id);
        setListaChamadoTotal(filtrarChamados);
      } else if (tipoAcessoModulo8 === 'A') {
        const filtrarChamados = res50.data.filter(
          a => a.COD_FUNCIONARIO_SOLICITANTE == id || a.COD_ADMIN_ATENDEU == id || a.COD_FUNCIONARIO == id
        );
        setListaChamadoTotal(filtrarChamados);
      } else {
        setListaChamadoTotal(res50.data);
      }


      const res2 = await axios.get(`${urlApi}central-ti/quantidade-chamado`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setQuantidadeChamado(res2.data);

      setAtualizaFinalizados(false);
    } catch (err) {
      console.log("Conexão falhou", err);
    }
  };


  useEffect(() => {
    if (tipoAcessoModulo8 !== null) {
      getDashboardFinalizado();
    }

  }, [atualizaFinalizados]);

  //---------------------------------------LISTA EQUIPAMENTO---------------------------------------------------//

  const [listaEquipamento, setListaEquipamento] = useState([]);
  const getListaEquipamentos = async () => {
    try {
      const res = await axios.get(`${urlApi}central-ti/lista-equipamentos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListaEquipamento(res.data);
      if (res.data) {

      }

    } catch (err) {
      console.log("Conexão falhou", err);
    }

  };

  useEffect(() => {
    getListaEquipamentos();
  }, []);

  //---------------------------------------MODAL NOVO CHAMADO---------------------------------------------------//

  const [isModalOpenNovoChamado, setIsModalOpenNovoChamado] = useState(false);
  const modalNovoChamado = () => {
    setIsModalOpenNovoChamado(!isModalOpenNovoChamado);

  };


  //---------------------------------------MODAL VER DE CHAMADO ABERTO---------------------------------------------------//

  const [verChamadoAberto, setVerChamadoAberto] = useState([])
  const [isModalOpenVerChamadoAberto, setIsModalOpenVerChamadoAberto] = useState(false);
  const modalVerChamadoAberto = (item) => {
    setIsModalOpenVerChamadoAberto(!isModalOpenVerChamadoAberto);
    setVerChamadoAberto(item);
  };


  //---------------------------------------MODAL EDITAR DE CHAMADO---------------------------------------------------//


  const [isModalOpenEditarChamado, setIsModalOpenEditarChamado] = useState(false);
  const modalEditarChamado = (item) => {
    setIsModalOpenEditarChamado(!isModalOpenEditarChamado);

  };

  //---------------------------------------MODAL ATENDER DE CHAMADO---------------------------------------------------//


  const [isModalOpenAtenderChamado, setIsModalOpenAtenderChamado] = useState(false);
  const modalAtenderChamado = (item) => {
    setIsModalOpenAtenderChamado(!isModalOpenAtenderChamado);

  };


  //---------------------------------------MODAL VER DE CHAMADO ATENDIMENTO---------------------------------------------------//

  const [verChamadoAtendimento, setVerChamadoAtendimento] = useState([])
  const [isModalOpenVerChamadoAtendimento, setIsModalOpenVerChamadoAtendimento] = useState(false);
  const modalVerChamadoAtendimento = (item) => {
    setIsModalOpenVerChamadoAtendimento(!isModalOpenVerChamadoAtendimento);
    setVerChamadoAtendimento(item);
  };


  //---------------------------------------MODAL FINALIZAR  CHAMADO---------------------------------------------------//


  const [isModalOpenFinalizarChamado, setIsModalOpenFinalizarChamado] = useState(false);
  const modalFinalizarChamado = (item) => {
    setIsModalOpenFinalizarChamado(!isModalOpenFinalizarChamado);

  };


  //---------------------------------------MODAL VER DE CHAMADO FINALIZADO---------------------------------------------------//

  const [verChamadoFinalizado, setVerChamadoFinalizado] = useState([])
  const [isModalOpenVerChamadoFinalizado, setIsModalOpenVerChamadoFinalizado] = useState(false);
  const modalVerChamadoFinalizado = (item) => {
    setIsModalOpenVerChamadoFinalizado(!isModalOpenVerChamadoFinalizado);
    setVerChamadoFinalizado(item);
  };

  //---------------------------------------MODAL VER DE CHAMADO CANCELADO---------------------------------------------------//

  const [verChamadoCancelado, setVerChamadoCancelado] = useState([])
  const [isModalOpenVerChamadoCancelado, setIsModalOpenVerChamadoCancelado] = useState(false);
  const modalVerChamadoCancelado = (item) => {
    setIsModalOpenVerChamadoCancelado(!isModalOpenVerChamadoCancelado);
    setVerChamadoCancelado(item);
  };


  //---------------------------------------MODAL APONTAR CHAMADOS---------------------------------------------------//


  const [isModalOpenApontamentos, setIsModalOpenApontamentos] = useState(false);
  const modalApontamentos = (item) => {
    setIsModalOpenApontamentos(!isModalOpenApontamentos);

  };


  //---------------------------------------MODAL APONTAR CHAMADOS GERAL---------------------------------------------------//


  const [isModalOpenApontamentosGeral, setIsModalOpenApontamentosGeral] = useState(false);
  const modalApontamentosGeral = () => {
    setIsModalOpenApontamentosGeral(!isModalOpenApontamentosGeral);

  };
  //-------------------------------------------------//
  const [lastUpdated, setLastUpdated] = useState(null);
  const [intervalo, setIntervalo] = useState(300000);

  useEffect(() => {


    const intervalId = setInterval(() => {
      getDashboard();
    }, intervalo);

    return () => clearInterval(intervalId); // limpar se intervalo mudar
  }, [intervalo]);




  return (

    <div style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden', width: '100vw', }}>


      {isModalOpenNovoChamado && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <RedButton onClick={() => {
                modalNovoChamado();
              }}>
                X
              </RedButton>
            </ButtonContainer>
            <NovoChamado
              urlApi={urlApi}
              setAtualizaDasboard={setAtualizaDasboard}
              usuarioEquipamento={usuarioEquipamento}
              tipoChamado={tipoChamado}
              subTipoChamado={subTipoChamado}
              itemSubTipoChamado={itemSubTipoChamado}
              modalNovoChamado={modalNovoChamado}
              tipoAcessoModulo8={tipoAcessoModulo8}
              listaEquipamento={listaEquipamento}
            />
            <ButtonContainer>
              <RedButton onClick={() => {
                modalNovoChamado();
              }}>
                Fechar
              </RedButton>
            </ButtonContainer>
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenVerChamadoAberto && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <RedButton onClick={() => {
                modalVerChamadoAberto();
              }}>
                X
              </RedButton>
            </ButtonContainer>
            <VerChamadoAberto
              urlApi={urlApi}
              listaEquipamento={listaEquipamento}
              usuarioEquipamento={usuarioEquipamento}
              tipoChamado={tipoChamado}
              subTipoChamado={subTipoChamado}
              itemSubTipoChamado={itemSubTipoChamado}
              verChamado={verChamadoAberto}
              setIsModalOpenVerChamado={setIsModalOpenVerChamadoAberto}
              setIsModalOpenEditarChamado={setIsModalOpenEditarChamado}
              setIsModalOpenAtenderChamado={setIsModalOpenAtenderChamado}
              setAtualizaDasboard={setAtualizaDasboard}
              tipoAcessoModulo8={tipoAcessoModulo8}
            />
            <ButtonContainer>
              <RedButton onClick={() => {
                modalVerChamadoAberto();
              }}>
                Fechar
              </RedButton>
            </ButtonContainer>
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenEditarChamado && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <RedButton onClick={() => {
                modalEditarChamado();
              }}>
                X
              </RedButton>
            </ButtonContainer>
            <EditarChamado
              urlApi={urlApi}
              setAtualizaDasboard={setAtualizaDasboard}
              listaEquipamento={listaEquipamento}
              usuarioEquipamento={usuarioEquipamento}
              tipoChamado={tipoChamado}
              subTipoChamado={subTipoChamado}
              itemSubTipoChamado={itemSubTipoChamado}
              modalNovoChamado={modalNovoChamado}
              verChamado={verChamadoAberto}
              tipoAcessoModulo8={tipoAcessoModulo8}
            />
            <ButtonContainer>
              <RedButton onClick={() => {
                modalEditarChamado();
              }}>
                Fechar
              </RedButton>
            </ButtonContainer>
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenAtenderChamado && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <RedButton onClick={() => {
                modalAtenderChamado();
              }}>
                X
              </RedButton>
            </ButtonContainer>
            <AtenderChamado
              urlApi={urlApi}
              listaEquipamento={listaEquipamento}
              usuarioEquipamento={usuarioEquipamento}
              tipoChamado={tipoChamado}
              subTipoChamado={subTipoChamado}
              itemSubTipoChamado={itemSubTipoChamado}
              verChamado={verChamadoAberto}
              setIsModalOpenVerChamado={setIsModalOpenVerChamadoAberto}
              setAtualizaDasboard={setAtualizaDasboard}
              setIsModalOpenAtenderChamado={setIsModalOpenAtenderChamado}
            />
            <ButtonContainer>
              <RedButton onClick={() => {
                modalAtenderChamado();
              }}>
                Fechar
              </RedButton>
            </ButtonContainer>
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenVerChamadoAtendimento && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <RedButton onClick={() => {
                modalVerChamadoAtendimento();
              }}>
                X
              </RedButton>
            </ButtonContainer>
            <VerChamadoAtendimento
              urlApi={urlApi}
              usuarioEquipamento={usuarioEquipamento}
              listaEquipamento={listaEquipamento}
              tipoChamado={tipoChamado}
              subTipoChamado={subTipoChamado}
              itemSubTipoChamado={itemSubTipoChamado}
              verChamado={verChamadoAtendimento}
              setIsModalOpenVerChamado={setIsModalOpenVerChamadoAtendimento}
              setIsModalOpenFinalizarChamado={setIsModalOpenFinalizarChamado}
              tipoAcessoModulo8={tipoAcessoModulo8}
              modalApontamentos={modalApontamentos}

            />
            <ButtonContainer>
              <RedButton onClick={() => {
                modalVerChamadoAtendimento();
              }}>
                Fechar
              </RedButton>
            </ButtonContainer>
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenFinalizarChamado && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <RedButton onClick={() => {
                modalFinalizarChamado();
              }}>
                X
              </RedButton>
            </ButtonContainer>
            <FinalizarChamado
              urlApi={urlApi}
              listaEquipamento={listaEquipamento}
              usuarioEquipamento={usuarioEquipamento}
              tipoChamado={tipoChamado}
              subTipoChamado={subTipoChamado}
              itemSubTipoChamado={itemSubTipoChamado}
              verChamado={verChamadoAtendimento}
              setIsModalOpenVerChamado={setIsModalOpenVerChamadoAtendimento}
              setIsModalOpenAtenderChamado={setIsModalOpenAtenderChamado}
              setAtualizaDasboard={setAtualizaDasboard}
              setIsModalOpenFinalizarChamado={setIsModalOpenFinalizarChamado}

            />
            <ButtonContainer>
              <RedButton onClick={() => {
                modalFinalizarChamado();
              }}>
                Fechar
              </RedButton>
            </ButtonContainer>
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenVerChamadoFinalizado && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <RedButton onClick={() => {
                modalVerChamadoFinalizado();
              }}>
                X
              </RedButton>
            </ButtonContainer>
            <VerChamadoFinalizado
              urlApi={urlApi}
              usuarioEquipamento={usuarioEquipamento}
              tipoChamado={tipoChamado}
              subTipoChamado={subTipoChamado}
              itemSubTipoChamado={itemSubTipoChamado}
              verChamado={verChamadoFinalizado}
              setIsModalOpenVerChamado={setIsModalOpenVerChamadoAtendimento}
              setIsModalOpenFinalizarChamado={setIsModalOpenFinalizarChamado}
              tipoAcessoModulo8={tipoAcessoModulo8}
              listaEquipamento={listaEquipamento}
              modalApontamentos={modalApontamentos}
            />
            <ButtonContainer>
              <RedButton onClick={() => {
                modalVerChamadoFinalizado();
              }}>
                Fechar
              </RedButton>
            </ButtonContainer>
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenVerChamadoCancelado && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <RedButton onClick={() => {
                modalVerChamadoCancelado();
              }}>
                X
              </RedButton>
            </ButtonContainer>
            <VerChamadoCanelado
              urlApi={urlApi}
              usuarioEquipamento={usuarioEquipamento}
              tipoChamado={tipoChamado}
              subTipoChamado={subTipoChamado}
              itemSubTipoChamado={itemSubTipoChamado}
              verChamado={verChamadoCancelado}
              setIsModalOpenVerChamado={setIsModalOpenVerChamadoAtendimento}
              setIsModalOpenFinalizarChamado={setIsModalOpenFinalizarChamado}
              tipoAcessoModulo8={tipoAcessoModulo8}
              listaEquipamento={listaEquipamento}
              modalApontamentos={modalApontamentos}
            />
            <ButtonContainer>
              <RedButton onClick={() => {
                modalVerChamadoCancelado();
              }}>
                Fechar
              </RedButton>
            </ButtonContainer>
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenApontamentos && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <RedButton onClick={() => {
                modalApontamentos();
              }}>
                X
              </RedButton>
            </ButtonContainer>
            <Apontamentos
              urlApi={urlApi}
              verChamadoAtendimento={verChamadoAtendimento}
              verChamadoFinalizado={verChamadoFinalizado}
              verChamadoCancelado={verChamadoCancelado}


            />
            <ButtonContainer>
              <RedButton onClick={() => {
                modalApontamentos();
              }}>
                Fechar
              </RedButton>
            </ButtonContainer>
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenApontamentosGeral && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <RedButton onClick={() => {
                modalApontamentosGeral();
              }}>
                Fechar
              </RedButton>
            </ButtonContainer>
            <ListaApontamentosGeral
              urlApi={urlApi}
              tipoAcessoModulo8={tipoAcessoModulo8}
            />
            <ButtonContainer>
              <RedButton onClick={() => {
                modalApontamentosGeral();
              }}>
                X
              </RedButton>
            </ButtonContainer>
          </ModalContent>
        </ModalContainer>
      )}



      <Div>

        <DivLayout>


          <Title>
            <TitleInt>
              <Title2>
                <DivTitle>


                  <ActionButton className="toggle-btn" onClick={handleVoltarDash}>
                    <IoMdArrowRoundBack className="gap" /> Voltar
                  </ActionButton>
                  <h2 style={{ width: '350px' }}>Central da TI</h2>
                </DivTitle>


              </Title2>
              <Title2>


                <DivBotoes >
                  <Button
                    onClick={modalNovoChamado}
                  >
                    Novo Chamado
                  </Button>
                  {(tipoAcessoModulo8 === 'A' || tipoAcessoModulo8 === 'G') && (
                    <Button

                      onClick={modalApontamentosGeral}
                    >
                      Apontamentos
                    </Button>
                  )}

                  {(tipoAcessoModulo8 === 'A' || tipoAcessoModulo8 === 'G') && (
                    <Button
                      active={abaAtiva === "dashboard"}
                      onClick={() => trocarAbaComImagem("dashboard")}
                    >
                      Chamados
                    </Button>
                  )}

                  {(tipoAcessoModulo8 === 'A' || tipoAcessoModulo8 === 'G') && (
                    <Button
                      active={abaAtiva === "locacao"}
                      onClick={() => trocarAbaComImagem("locacao")}
                    >
                      Locação
                    </Button>
                  )}

                  {(tipoAcessoModulo8 === 'A' || tipoAcessoModulo8 === 'G') && (
                    <Button
                      active={abaAtiva === "cadastrar"}
                      onClick={() => trocarAbaComImagem("cadastrar")}
                    >
                      Equipamentos
                    </Button>
                  )}

                  {(tipoAcessoModulo8 === 'A') && (
                    <Button
                      active={abaAtiva === "problemas"}
                      onClick={() => trocarAbaComImagem("problemas")}
                    >
                      Tipos
                    </Button>
                  )}

                </DivBotoes>







              </Title2>
            </TitleInt>
          </Title>


          <Container >
            {loadingImage ? (
              <Div2
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100vh",
                  width: "100%",
                  textAlign: "center",
                }}
              >
                <img
                  src={loadingImage}
                  alt="Carregando..."
                  style={{
                    width: 600,
                    height: "auto",
                    animation: "zoomIn 0.8s ease-out forwards",
                  }}
                />
                <style>
                  {`
                  @keyframes zoomIn {
                    from {
                      opacity: 0;
                      transform: scale(0.8);
                    }
                    to {
                      opacity: 1;
                      transform: scale(1);
                    }
                  }
                `}
                </style>
              </Div2>
            ) : (
              <>
                {abaAtiva === "dashboard" && (
                  <DashboardChamado
                    urlApi={urlApi}
                    listaEquipamento={listaEquipamento}
                    listaChamadoAberto={listaChamadoAberto}
                    listaChamadoAtendimento={listaChamadoAtendimento}
                    listaChamadoFinalizado={listaChamadoFinalizado}
                    listaChamadoCancelado={listaChamadoCancelado}
                    listaChamadoTotal={listaChamadoTotal}
                    quantidadeChamado={quantidadeChamado}
                    modalVerChamadoAberto={modalVerChamadoAberto}
                    modalVerChamadoAtendimento={modalVerChamadoAtendimento}
                    modalVerChamadoFinalizado={modalVerChamadoFinalizado}
                    modalVerChamadoCancelado={modalVerChamadoCancelado}
                    modalApontamentos={modalApontamentos}
                    tipoAcessoModulo8={tipoAcessoModulo8}
                    setAtualizaFinalizados={setAtualizaFinalizados}
                    atualizaFinalizados={atualizaFinalizados}
                    intervalo={intervalo}
                    setIntervalo={setIntervalo}
                    lastUpdated={lastUpdated}
                    setLastUpdated={setLastUpdated}

                  />
                )}
                {abaAtiva === "locacao" && (
                  <GestaoContrato
                    urlApi={urlApi}
                  />
                )}

                {abaAtiva === "cadastrar" && (
                  <GestaoEquipamento
                    urlApi={urlApi}
                  />
                )}

                {abaAtiva === "problemas" && (
                  <GestaoTiposProblemas
                    urlApi={urlApi}
                  />
                )}
              </>
            )}
          </Container>

        </DivLayout>



        <Div2>
          <ToastContainer
            autoClose={2500}
            position={toast.POSITION.BOTTOM_LEFT}
            style={{ width: '400px', fontSize: '22px' }}
          />

        </Div2>
      </Div>

      <GlobalStyle />
    </div>

  );
}

export default Usuarios;
